import React, { useState, useEffect } from 'react';

// import { MagazineMenuData } from '../../public/MenuData';
import { ajaxor0, ajaxor2 } from '../common/basic';

import getNLS from '../common/_NLS';

export default props=>{
  const [rootMenu, setRoot] = useState('');
  const [dMain, setMainMenu] =useState('');

  // 모바일 메뉴를 보이거나 숨기거나 한다.
  useEffect(() => {
    if (dMain == '' && props.hideMobileMenu) {
      setMainMenu('none');
      props.hideMobileMenu();
      return;
    }

    setMainMenu(props.isMM);
    return () => { ; };
  }, [props.isMM]);

  useEffect(() => {
    setRoot(props.depart);
    return () => { ; };
  }, [props.depart]);




  // 매거진 카테고리정보 얻기
  const [vCategoryList, setCategoryList] = useState([]);
  // 매거진 카테고리정보 얻기
  useEffect(() => {
    ajaxor0({
      url: "/magazineCategory", // magag... 오타고침
      callback: callback,
    });
    function callback(rd) {
      setCategoryList(JSON.parse(rd.data));
    }

    return () => { ; }
  }, []);



  const jsx = (<div className="pan3 generalfont" >

    <style jsx>{`
  * {
    box-sizing: border-box;
    margin:0;
    border:0;
    padding:0;
  }

.pan3{
  width: 100%;
  height: 50px;
  line-height: 50px;
  vertical-align: middle;

  margin: 0 auto;
  // border: solid;
  background-color: #ffffff;
}

.display-inline{
  display: inline-block;
  margin: 0 7px;
  vertical-align: middle;
  
}

.hilightable{
  height: 45px;

  font-size: 16px;
  font-weight: bold;
  color: #adb5bd;
  border-bottom: solid 2px;

  border-color: white;
  /* transition: color 1s; */
}

.hilighted{
  color: black;

  border-color: black;
}

.generalfont{
  font-family: NotoSansCJKkr;
  font-size: 14px;
  color: #adb5bd;

}



.x2{
    float: right;
    margin: 20px;
}

@media all and (max-width:606px) {
  .pan3{
    display: ${dMain};
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 12;
    margin:0;
  }

  .mbuffer{
    width: 50%;
    height: 60px;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
  }
  
  .hilightable,
  .highlightable{
    /* 0418 모바일 팝업메뉴 각항목 폰트, 눈으로 확인하여 20으로하기로함 */
    font-size: 20px;
  }

}


`}</style>
  <img className="x2 dibom" onClick={() => props.hideMobileMenu()} src="/assets/images-m/x_2.svg" />
  <div className="dbom">&nbsp;</div>
  <div className="dbom">&nbsp;</div>

  <div className="dib mbuffer">
    <a href={"/magazine/list"}>
      <div 
        className={"display-inline hilightable " + ("전체" == rootMenu ? " hilighted " : "")} 
      >{getNLS("전체")}</div>
    </a>
  </div>
    {vCategoryList.map((v,i,a)=>
    
    <div key={i} className="dib mbuffer">
      <a href={"/magazine/list?kw=" + v}>
        <div 
          className={"display-inline hilightable " + (v==rootMenu?" hilighted ":"")} 
          // onClick={()=>setRoot(v)}
        >{getNLS(v)}</div>
      </a>
    </div>
  )}

  </div>);
  return jsx;
};
